"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = void 0;

var getCookie = function getCookie(name) {
  var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
  return match ? match[1] : null;
};

exports.getCookie = getCookie;